import * as React from "react";
import { forwardRef } from "react";
const SvgVolumeDown = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", fill: "none", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14 7.97V16.02C15.48 15.29 16.5 13.77 16.5 12C16.5 10.23 15.48 8.71 14 7.97ZM3 9V15H7L12 20V4L7 9H3ZM10 8.83V15.17L7.83 13H5V11H7.83L10 8.83Z", fill: "currentcolor" }));
const ForwardRef = forwardRef(SvgVolumeDown);
export default ForwardRef;
